import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { API_URL } from "./utils";

export const authClient = createAuthClient({
  baseURL: API_URL,
  plugins: [adminClient()],
});
